module.exports = __webpack_public_path__ + "static/media/lupa.f3a30cdb.svg";